import { gql } from '@apollo/client'
import { workOrderRemarksActivityFragment, workOrderTasksFragment } from './graphql'
import type { UseActionResult, UseMutationProps } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import type { SortWorkOrderTasksArgs, WorkOrder } from '@ztechapps/common.contract'

export const sortWorkOrderTasksQuery = gql`
  mutation sortWorkOrderTasks($input: SortWorkOrderTasksArgs!) {
    sortWorkOrderTasks(input: $input) {
      _id
      tasks {
        ...workOrderTasksFragment
      }
    }
  }
  ${workOrderTasksFragment}
  ${workOrderRemarksActivityFragment}
`

export const useSortWorkOrderTasks = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<WorkOrder, SortWorkOrderTasksArgs> => {
  query = query ?? sortWorkOrderTasksQuery

  return useActionMutation({
    query,
    ...props,
  })
}
